import { Fragment, type ReactNode } from 'react';

/**
 * A translated sentence with elements in it: `{plan}` in the dictionary string
 * becomes the bold plan name or the link passed here, so each language can put
 * it wherever its word order wants. Fill plain-text placeholders with `t` first;
 * any placeholder not named in `nodes` is left as it stands.
 */
export function withNodes(text: string, nodes: Readonly<Record<string, ReactNode>>): ReactNode {
  return text.split(/(\{\w+\})/).map((part, index) => {
    const name = /^\{(\w+)\}$/.exec(part)?.[1];
    return name !== undefined && name in nodes ? <Fragment key={index}>{nodes[name]}</Fragment> : part;
  });
}
